/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './intra-op-chart.reducer';

export const IntraOPChartDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const intraOPChartEntity = useAppSelector(state => state.intraOPChart.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="intraOPChartDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.intraOPChart.detail.title">IntraOPChart</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.id">Id</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.id}</dd>
          <dt>
            <span id="oxygen">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.oxygen">Oxygen</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.oxygen}</dd>
          <dt>
            <span id="nitrousOxide">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.nitrousOxide">Nitrous Oxide</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.nitrousOxide}</dd>
          <dt>
            <span id="halothane">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.halothane">Halothane</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.halothane}</dd>
          <dt>
            <span id="isoflurane">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.isoflurane">Isoflurane</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.isoflurane}</dd>
          <dt>
            <span id="sevoflurane">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.sevoflurane">Sevoflurane</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.sevoflurane}</dd>
          <dt>
            <span id="desflurane">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.desflurane">Desflurane</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.desflurane}</dd>
          <dt>
            <span id="invasiveLines">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.invasiveLines">Invasive Lines</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.invasiveLines}</dd>
          <dt>
            <span id="urineOutput">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.urineOutput">Urine Output</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.urineOutput}</dd>
          <dt>
            <span id="bloodLoss">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.bloodLoss">Blood Loss</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.bloodLoss}</dd>
          <dt>
            <span id="otherLosses">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.otherLosses">Other Losses</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.otherLosses}</dd>
          <dt>
            <span id="opVentilation">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.opVentilation">Op Ventilation</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.opVentilation}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.active">Active</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{intraOPChartEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPChart.surgery">Surgery</Translate>
          </dt>
          <dd>{intraOPChartEntity.surgery ? intraOPChartEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPChart.patient">Patient</Translate>
          </dt>
          <dd>{intraOPChartEntity.patient ? intraOPChartEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPChart.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{intraOPChartEntity.anaesthesiologist ? intraOPChartEntity.anaesthesiologist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPChart.surgeon">Surgeon</Translate>
          </dt>
          <dd>{intraOPChartEntity.surgeon ? intraOPChartEntity.surgeon.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPChart.nurse">Nurse</Translate>
          </dt>
          <dd>{intraOPChartEntity.nurse ? intraOPChartEntity.nurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPChart.vitals">Vitals</Translate>
          </dt>
          <dd>{intraOPChartEntity.vitals ? intraOPChartEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPChart.preOpAnaesthesiaChart">Pre Op Anaesthesia Chart</Translate>
          </dt>
          <dd>{intraOPChartEntity.preOpAnaesthesiaChart ? intraOPChartEntity.preOpAnaesthesiaChart.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/intra-op-chart" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/intra-op-chart/${intraOPChartEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntraOPChartDetail;
